// extracted by mini-css-extract-plugin
export var audioPlayer = "_qw-0";